import { forwardRef, useMemo } from 'react';

import { SupportedProcessors } from '../../constants';

import { AdyenProvider } from './AdyenProvider';
import { StripeProvider } from './StripeProvider';

const GatewayComponent = {
  [SupportedProcessors.STRIPE]: StripeProvider,
  [SupportedProcessors.ADYEN]: AdyenProvider,
};

export const PaymentProvider = forwardRef(({ processor }: { processor: string}, ref) => {
  const Component = useMemo(() => GatewayComponent[processor], [processor]);
  return (
    <Component ref={ref} />
  );
});
